export const firstCharToLowerCase = (value) => (value ? value.charAt(0).toLowerCase() + value.slice(1) : '');
